export default function loadWidget(jsHref) {
  // Если уже зарегистрирован — ничего не делаем
  if (customElements.get('ai-chat-widget')) return Promise.resolve(false);

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = jsHref;
    script.async = true;

    script.onload = () => resolve(true);
    script.onerror = () => {
      resolve(false);
    };

    document.head.appendChild(script);
  });
}
